import { render, staticRenderFns } from "./categorySliderItem.vue?vue&type=template&id=c50260aa&scoped=true&lang=pug&"
import script from "./categorySliderItem.vue?vue&type=script&lang=js&"
export * from "./categorySliderItem.vue?vue&type=script&lang=js&"
import style0 from "./categorySliderItem.vue?vue&type=style&index=0&id=c50260aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50260aa",
  null
  
)

export default component.exports